import { MutationTree, Mutation } from 'vuex';
import { IArticle, IState, IValue } from './state';
import { ActionPayload, IValuePayload } from './actions';

type MutationHandler<PayloadType> = (state: IState, payload: ActionPayload<PayloadType>) => any;

const setStateMutation: MutationHandler<IState> = (state, { payload }) => {
	Object.assign(state, payload);
}

const setSearchQueryMutation: MutationHandler<string> = (state, { payload }) => {
	Object.assign(state, {
		query: payload
	});
}

const setNewsMutation: MutationHandler<IArticle[]> = (state, { payload }) => {
	Object.assign(state, {
		news: payload,
	});
}

const setTotalMutation: MutationHandler<IArticle[]> = (state, { payload }) => {
	Object.assign(state, {
		total: payload,
	});
}

const resetPageMutation: MutationHandler<undefined> = (state, { payload }) => {
	Object.assign(state, {
		page: 0,
	});
}

// Change selected value (true/false)
const toggleValueMutation: MutationHandler<IValuePayload> = (state, { payload }) => {
	// If there is a filter with the same name that comes from payload
	const filter = state.categoryFilter.find(f => f.name === payload.name);
	if(filter) {
		// Value = the value that filter and payload shares
		// Change selected on that/thoes value/values
		const value = filter.values.find(f => f.value === payload.value)
		if(value) {
			Object.assign(value, {
				selected: payload.selected,
			})
		}

	}
}

const setCurrentPageMutation: MutationHandler<number> = (state, { payload }) => {
	Object.assign(state, { 
		page: payload
	});
}

const setPagesMutation: MutationHandler<number> = (state, { payload }) => {
	Object.assign(state, {pages: payload});
}

// Set all checkboxes to false and start/end date to empty strings
const clearFiltersMutation: MutationHandler<number> = (state, { payload }) => {
	state.categoryFilter.forEach(cf => {
		cf.values.forEach(v => Object.assign(v, {selected: false}))
	})
	Object.assign(state.date, {
		start: '',
		end: ''
	})
}

const setStartDateMutation: MutationHandler<number> = (state, { payload }) => {
	Object.assign(state.date, { 
		start: payload
	});
}

const setEndDateMutation: MutationHandler<number> = (state, { payload }) => {
	Object.assign(state.date, { 
		end: payload
	});
}

const setSortMutation: MutationHandler<string> = (state, { payload }) => {
	state.sort.forEach(s => {
		if(s.name === payload) {
			Object.assign(s, { 
				active: true
			});
		} else {
			Object.assign(s, { 
				active: false
			});
		}
	});
}

const mutations: MutationTree<IState> = {
	setState: setStateMutation,
	setSearchQuery: setSearchQueryMutation,
	setNews: setNewsMutation,
	setTotal: setTotalMutation,
	resetPage: resetPageMutation,
	toggleValue: toggleValueMutation,
	setCurrentPage: setCurrentPageMutation,
	setPages: setPagesMutation,
	clearFilters: clearFiltersMutation,
	setStartDate: setStartDateMutation,
	setEndDate: setEndDateMutation,
	setSort: setSortMutation,
}

export default mutations
